import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { TranslationService } from 'src/app/modules/i18n/translation.service';
import { HospitalService } from '../_services';
import { Meta } from '@angular/platform-browser';
import { EnvService } from 'src/app/service/env.service';
declare var $: any;
type Lang = 'ar' | 'en';

interface ValueItem {
  icon: string;
  title: string;
  text: string;
}

@Component({
  selector: 'app-home-one',
  templateUrl: './home-one.component.html',
  styleUrls: ['./home-one.component.scss']
})
export class HomeComponent implements OnInit, OnDestroy {
  language: any;
  HospitalNews;
  HospitalPartners;
  isLoading$: Observable<boolean>;
  private subscriptions: Subscription[] = []; // Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/
  values: ValueItem[] = [];

  constructor(public EnvService : EnvService ,private metaTagService: Meta,private HospitalService: HospitalService, private translationService: TranslationService) { }

    // --- helpers ---
  private setLanguage(lang: Lang): void {
    this.language = lang;
    this.values = this.buildValues(lang);
  }
 private buildValues(lang: Lang): ValueItem[] {
    const ar = lang === 'ar';
    return [
      {
        icon: 'icofont-unique-idea me-2',
        title: ar ? 'الحكمة' : 'Stewardship  ',
        text: ar
          ? 'من اتخاذ القرارات التشـــــــــــــــغيلية بناءً على الخطط والميزانيات المعتمدة'
          : 'in operational decision-making based on approved business plans and budgets (Post to Reform).'
      },
      {
        icon: 'icofont-verification-check me-2',
        title: ar ? 'النزاهة' : 'Integrity',
        text: ar
          ? 'لتحقيق  النمو الاقتصادي.'
          : 'to capture economies of scale.'
      },
      {
        icon: 'icofont-diamond me-2',
        title: ar ? 'التميز' : 'Excellence',
        text: ar
          ? 'ومؤشــــــــــــرات أداء رئيســية لضمان الرقابة والإشراف.'
          : 'and KPIs to maintain oversight.'
      },
       {
        icon: 'icofont-ui-user-group me-2',
        title: ar ? 'التعاون' : 'Collaboration',
        text: ar
          ? 'عبر المنظمة لتوحيد الأهداف علــى جميع المستويات.'
          : 'across the organization to unify goals across the levels .'
      },
       {
        icon: 'icofont-bullseye me-2',
        title: ar ? 'التأثير' : 'Impact',
        text: ar
          ? 'لتعزيز التكامل واتخاذ القرارات المستندة إلى البيانات.'
          : 'to enhance integration and data-driven decision-making.'
      },{
        icon: 'icofont-brainstorming me-2',
        title: ar ? 'الابتكار' : 'Innovation',
        text: ar
          ? 'لتعزيز التكامل واتخاذ القرارات المستندة إلى البيانات.'
          : 'to enhance integration and data-driven decision-making.'
      }
    ];
  }
  current = 0;          // أول كارت ظاهر
  visible = 3;          // عدد الكروت الظاهرة على الشاشات الكبيرة
  get atStart() { return this.current === 0; }
  get atEnd()   { return this.current >= this.values.length - this.visible; }

  get transform() {
    const step = 100 / this.visible;           // نسبة إزاحة كل كارت
    return `translateX(-${this.current * step}%)`;
  }

  @HostListener('window:resize') onResize() { this.updateVisible(); }

  updateVisible() {
    const w = window.innerWidth;
    this.visible = w < 576 ? 1 : w < 992 ? 2 : 3;
    // امنع المؤشر من الخروج بعد تغيّر العرض
    if (this.current > this.values.length - this.visible) {
      this.current = Math.max(0, this.values.length - this.visible);
    }
  }

  prev() { if (!this.atStart) this.current--; }
  next() { if (!this.atEnd)   this.current++; }
  
  ngOnInit(): void {
    this.updateVisible();
    this.metaTagService.updateTag({ 
      name: 'description', 
      content: 'Family Care is a leading healthcare provider in Saudi Arabia, offering top-notch medical services and patient care for families' 
    });
    this.metaTagService.updateTag({ 
      name: 'keywords', 
      content: 'healthcare Saudi Arabia, family medical services, patient care, medical provider' 
    });
    this.language = this.translationService.getSelectedLanguage();
    const lang = this.translationService.getSelectedLanguage() as Lang;
    this.setLanguage(lang);
    const sb = this.HospitalService.GetHospitalNews().subscribe(res => {

      if (res.data != null && res.isSuccess) {
        this.HospitalNews = res.data;
        setTimeout(() => {
          let items = document.querySelectorAll('.HospitalNewscarousel .HospitalNewscarousel-item');
          items.forEach((el) => {
            const minPerSlide = 3;
            let next = el.nextElementSibling;
            for (var i = 1; i < minPerSlide; i++) {
              if (!next) {
                // wrap carousel by using first child
                next = items[0];
              }
              let cloneChild = next.cloneNode(true) as any;
              el.appendChild(cloneChild.children[0]);
              next = next.nextElementSibling;
            }
          });
        }, 0);
      }
    });
    this.subscriptions.push(sb);
    const sb2 = this.HospitalService.GetHospitalPartners().subscribe(res => {

      if (res.data != null && res.isSuccess) {
        this.HospitalPartners = res.data;
        setTimeout(() => {
          let items = document.querySelectorAll('.HospitalPartnerscarousel .HospitalPartnerscarousel-item');
          items.forEach((el) => {
            const minPerSlide = 4;
            let next = el.nextElementSibling;
            for (var i = 1; i < minPerSlide; i++) {
              if (!next) {
                // wrap carousel by using first child
                next = items[0];
              }
              let cloneChild = next.cloneNode(true) as any;
              el.appendChild(cloneChild.children[0]);
              next = next.nextElementSibling;
            }
          });
        }, 0);
     
      }
    });
    this.subscriptions.push(sb2);
    this.isLoading$ = this.HospitalService.isLoading$;


  }
  ngOnDestroy() {
    this.subscriptions.forEach((sb) => sb.unsubscribe());
  }
  
}
